const VERIFIED_POLICY = Symbol('verified_server_product_policy');
const CURATED_CAPABILITY = 'curated_meta_v1';
const CURATED_CAMPAIGN_KIND = 'curated_ads_v1';
const LOCKED_DECISION = Object.freeze({
  ok: false,
  code: 'mvp_capability_locked',
});
const EMPTY_NAVIGATION = Object.freeze({
  active: Object.freeze([]),
  locked: Object.freeze([]),
});

const MVP_ACTIVE_NAVIGATION = Object.freeze([
  Object.freeze({ route: 'home', label: 'Home', icon: 'home' }),
  Object.freeze({ route: 'campaigns', label: 'Campaigns', icon: 'campaigns' }),
  Object.freeze({ route: 'leads', label: 'Leads', icon: 'leads' }),
  Object.freeze({ route: 'company', label: 'Company', icon: 'company' }),
  Object.freeze({ route: 'billing', label: 'Billing', icon: 'billing' }),
]);

const MVP_LOCKED_NAVIGATION = Object.freeze([
  Object.freeze({ route: 'reports', label: 'Reports', icon: 'reports' }),
  Object.freeze({ route: 'brand-research', label: 'Brand research', icon: 'brand' }),
  Object.freeze({ route: 'library', label: 'Library', icon: 'library' }),
  Object.freeze({ route: 'onboarding', label: 'Onboarding', icon: 'onboarding' }),
  Object.freeze({ route: 'funnels', label: 'Funnels', icon: 'funnels' }),
  Object.freeze({ route: 'videos', label: 'Videos', icon: 'videos' }),
  Object.freeze({ route: 'settings', label: 'Integrations', icon: 'integrations' }),
]);

function exactStringArray(value) {
  if (!Array.isArray(value)) return null;
  const result = [];
  for (const item of value) {
    if (typeof item !== 'string' || !item || item.trim() !== item || result.includes(item)) return null;
    result.push(item);
  }
  return result;
}

export function normalizeTenantProductPolicy(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  if (value.capability !== CURATED_CAPABILITY || value.campaignKind !== CURATED_CAMPAIGN_KIND) return null;

  const active = exactStringArray(value.routes?.active);
  const locked = exactStringArray(value.routes?.locked);
  const actions = exactStringArray(value.actions);
  if (!active || !locked || !actions || active.some((route) => locked.includes(route))) return null;

  const policy = {
    capability: CURATED_CAPABILITY,
    campaignKind: CURATED_CAMPAIGN_KIND,
    routes: {
      active: Object.freeze(active),
      locked: Object.freeze(locked),
    },
    actions: Object.freeze(actions),
  };
  Object.defineProperty(policy, VERIFIED_POLICY, { value: true });
  Object.freeze(policy.routes);
  return Object.freeze(policy);
}

export function tenantRouteDecision(policy, routeName) {
  if (
    !policy?.[VERIFIED_POLICY]
    || typeof routeName !== 'string'
    || !policy.routes.active.includes(routeName)
  ) {
    return LOCKED_DECISION;
  }
  return Object.freeze({ ok: true, routeName });
}

export function hasNamedTenantAction(policy, action) {
  return Boolean(
    policy?.[VERIFIED_POLICY]
    && typeof action === 'string'
    && policy.actions.includes(action),
  );
}

export function tenantMvpNavigation(policy) {
  if (!policy?.[VERIFIED_POLICY]) return EMPTY_NAVIGATION;
  return Object.freeze({
    active: Object.freeze(
      MVP_ACTIVE_NAVIGATION.filter(({ route }) => policy.routes.active.includes(route)),
    ),
    locked: Object.freeze(
      MVP_LOCKED_NAVIGATION.filter(({ route }) => policy.routes.locked.includes(route)),
    ),
  });
}

export function hasPlatformCatalogCapability(platform) {
  return Boolean(
    platform?.admin === true
    && platform?.role === 'platform_admin'
    && Array.isArray(platform.capabilities)
    && platform.capabilities.includes('platform.catalog.manage'),
  );
}
